import { HeaderLogo } from "components/header/styled";
import { Box, Typography, useTheme } from "@mui/material";
import { Brick } from "components/Brick";
import { OnboardingCardV2 } from "components/OnBoarding/styled";

import { FullViewContainer } from "components/OnBoarding/styled";
import useStepper from "v2/components/base/Stepper/hooks/useStepper";
import Stepper from "v2/components/base/Stepper/ui";
import { OnBoardingConfigs } from "../../utils/configs";
import CabalTownLogo from "assets/icons/cabal-town-logo.png";
import { RetroButton } from "components/RetroButton";

export const OnboardingWrapper = ({
  onBoardingConfig,
  handleOnboard,
}: {
  handleOnboard: () => void;
  onBoardingConfig: OnBoardingConfigs;
}) => {
  const { slide, handleNextSlide } = useStepper();
  const theme = useTheme();

  return (
    <FullViewContainer>
      <OnboardingCardV2
        sx={{
          display: "flex",
          position: "relative",
          overflowX: "scroll",
          scrollSnapType: "x mandatory",
          msScrollSnapPointsX: "repeat(100vw)",
          width: "100vw",
        }}>
        <Box
          sx={{
            position: "fixed",
            top: "24px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}>
          <Brick variant="darker">
            <Box
              width="100%"
              height="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
              padding={theme.spacing(0.3)}>
              <HeaderLogo src={CabalTownLogo} alt="cabal-town-logo" />
            </Box>
          </Brick>
        </Box>
        <Box
          sx={{
            position: "fixed",
            bottom: "24px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <Box
            sx={{
              display: "flex",
              gap: "16px",
              padding: "12px 0 16px",
            }}>
            <Stepper slide={slide} totalSlides={onBoardingConfig.length} />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0",
              gap: "10px",
              width: "100%",
              maxWidth: "400px",
            }}>
            {slide === 2 ? (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "400px",
                  padding: "0 36px",
                }}>
                <RetroButton variant="primary" onClick={handleOnboard}>
                  <Box padding="12px 0">
                    <Typography variant="title-h3">START NOW</Typography>
                  </Box>
                </RetroButton>
              </Box>
            ) : (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "400px",
                  padding: "0 36px",
                }}>
                <RetroButton variant="primary" onClick={handleNextSlide}>
                  <Box padding="12px 0">
                    <Typography variant="title-h3">Next</Typography>
                  </Box>
                </RetroButton>
              </Box>
            )}
          </Box>
        </Box>
      </OnboardingCardV2>
    </FullViewContainer>
  );
};

export default OnboardingWrapper;
